module.exports = __webpack_public_path__ + "img/floral-7887374_1280.890c04b9.jpg";